import UrlService from '../../../services/UrlService';
import axiosActions from '../axiosHelpers';
import { uuidv4 } from '../../../utils/uuid';

export const FETCH_VEHICLES_WITH_DRIVE_TIME = axiosActions('VEHICLES_WITH_DRIVE_TIME_LOAD');

/**
 * Fetch which of the supplied vehicleIds have drive-time data available.
 * Dispatches FETCH_VEHICLES_WITH_DRIVE_TIME.START; backend returns
 * { vehicleIdsWithDriveTime: string[] }.
 */
export const fetchVehiclesWithDriveTime = (companyId, vehicleIds) => ({
  type: FETCH_VEHICLES_WITH_DRIVE_TIME.START,
  payload: {
    actionId: uuidv4(),
    request: {
      method: 'post',
      url: UrlService.vehiclesWithDriveTime(companyId),
      data: { vehicleIds },
    },
  },
});
